import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  { q: "¿Qué es Autofinanza?", a: "Autofinanza es una plataforma tecnológica de intermediación que analiza tu perfil económico y crediticio para mostrarte únicamente las alternativas donde tienes probabilidad real de ser aceptado, ya sea por crédito, arrendamiento o pago de contado." },
  { q: "¿Iniciar mi precalificación afecta mi historial crediticio?", a: "No. La precalificación es una declaración informativa de tu parte y no representa una consulta formal a Buró de Crédito. Cualquier consulta formal posterior requerirá tu autorización explícita por separado." },
  { q: "¿Autofinanza otorga los créditos?", a: "No. Autofinanza no otorga créditos ni garantiza su aprobación. Las condiciones, aprobación y contratación son determinadas exclusivamente por cada institución participante." },
  { q: "¿Cuánto tiempo toma el proceso?", a: "Menos de un minuto. Respondes un formulario corto y al finalizar recibirás la información que mejor se ajuste a tu perfil." },
  { q: "¿Tiene algún costo?", a: "No. Iniciar tu precalificación es totalmente gratuito y sin compromiso." },
  { q: "¿Mis datos están seguros?", a: "Sí. Protegemos tu información con medidas de seguridad de nivel bancario y solo la compartimos con instituciones cuando tú lo solicitas o autorizas." },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-16 md:py-20" style={{ background: "var(--af-black)" }}>
      <div className="af-container max-w-3xl">
        <div className="text-center mb-10">
          <div className="text-af-orange-core font-display uppercase tracking-widest text-sm mb-2">Preguntas frecuentes</div>
          <h2 className="h-impact text-white text-3xl md:text-4xl">Resolvemos tus dudas</h2>
        </div>
        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}
              className="af-card px-5 border-af-border-dark">
              <AccordionTrigger className="text-white hover:no-underline text-left text-base">{f.q}</AccordionTrigger>
              <AccordionContent className="text-white/65 text-sm leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
